<template>
    <div class="status-page">
        <div class="status-container">
            <!-- Success Icon -->
            <div v-if="isSuccess" class="status-icon success-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            
            <!-- Failed Icon -->
            <div v-else class="status-icon failed-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <!-- Status Title -->
            <h1 class="status-title" :class="{ 'success-title': isSuccess, 'failed-title': !isSuccess }">
                {{ isSuccess ? 'Success!' : 'Failed!' }}
            </h1>

            <!-- Status Message -->
            <p class="status-message">
                <template v-if="isSuccess">
                    We have received your payment, if it has not arrived, please find the payment UTR and contact the account manager, we will process your request as soon as possible.
                </template>
                <template v-else>
                    Your payment could not be processed. Please check your payment details and try again. If the issue persists, please contact the account manager with your payment UTR.
                </template>
            </p>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

// Determine success/failure based on query param 'st'
// Assuming 'st' = 'success' or similar for success, anything else or missing = failed
const isSuccess = computed(() => {
    const st = route.query.st;
    // You can adjust this logic based on your actual query param values
    // For example: st === 'success' or st === '1' or st === 'true'
    return st === 'success' || st === '1' || st === 'true' || st === 'SUCCESS';
});

onMounted(() => {
    // If no status query param, redirect or show failed
    if (!route.query.st) {
        // Optionally redirect to recharge page
        router.push("/recharge");
    }
    else{
        setTimeout(() => {
            router.push("/recharge");
        }, 2000);
    }
});
</script>

<style scoped>
.status-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 2rem 1rem;
}

.status-container {
    text-align: center;
    max-width: 500px;
    width: 100%;
}

.status-icon {
    width: 120px;
    height: 120px;
    margin: 0 auto 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 4px solid;
}

.success-icon {
    background-color: #10b981;
    border-color: #10b981;
    color: #ffffff;
}

.failed-icon {
    background-color: #ef4444;
    border-color: #ef4444;
    color: #ffffff;
}

.status-icon svg {
    width: 60px;
    height: 60px;
}

.status-title {
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 1.5rem 0;
    line-height: 1.2;
}

.success-title {
    color: #10b981;
}

.failed-title {
    color: #ef4444;
}

.status-message {
    font-size: 0.95rem;
    color: #6b7280;
    line-height: 1.6;
    margin: 0;
    padding: 0 1rem;
}

@media (max-width: 576px) {
    .status-icon {
        width: 100px;
        height: 100px;
        margin-bottom: 1.5rem;
    }

    .status-icon svg {
        width: 50px;
        height: 50px;
    }

    .status-title {
        font-size: 1.75rem;
        margin-bottom: 1rem;
    }

    .status-message {
        font-size: 0.9rem;
        padding: 0 0.5rem;
    }
}

/* Animation for icon appearance */
.status-icon {
    animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
